// Albanian translations
const al = {
  // Navigation
  nav: {
    home: "Shtëpia e Ullishtes",
    about: "Rreth Nesh",
    menu: "Menuja",
    blog: "Blogu",
    gallery: "Galeria",
    contact: "Kontakti"
  },
  // Hero Section
  hero: {
    title: "Ullishtja Agroturizem",
    badge: "Përvojë Autentike Shqiptare",
    description: "Zbuloni shijen e traditës në zemrën e Shqipërisë. Përbërës të freskët, receta të vjetra dhe mikpritje e ngrohtë që nga viti 2021.",
    cta: "Rezervime",
    viewMenu: "Shiko Menunë",
    viewMore: "Shiko Më Shumë",
    highlights: {
      farmFresh: "Përbërës të Freskët",
      traditionalRecipes: "Receta Tradicionale",
      mountainViews: "Pamje 360°"
    },
    openDaily: "Hapur Çdo Ditë",
    googleReviews: "Recensione Google",
    loadingReviews: "Duke ngarkuar recensionet..."
  },
  // About Section
  about: {
    title: "Historia Jonë",
    text1: "E vendosur në qytetin e bukur dhe antik shqiptar të Durrësit, Ullishtja Agroturizem ofron një përvojë autentike nga ferma në tavolinë. Restoranti ynë kremton traditat e pasura kulinare të Shqipërisë, duke përdorur përbërës të freskët nga kopshtet tona dhe fermat lokale.",
    text2: "E themeluar në vitin 2021, ne krenohemi që shërbejmë ushqime tradicionale shqiptare të përgatitura me dashuri dhe kujdes, ashtu si i bënin të parët tanë. Çdo pjatë tregon një histori të trashëgimisë dhe profesionalizmit tonë.",
    features: {
      fresh: {
        title: "🫒 Përbërës të Freskët",
        desc: "Të marrë lokalisht nga ferma jonë dhe partnerët e besuar"
      },
      views: {
        title: "🏔️ 360°",
        desc: "Pamje mahnitëse të kodrave shqiptare dhe qytetit të Durrësit"
      },
      recipes: {
        title: "👨‍🍳 Receta Tradicionale",
        desc: "Ushqime autentike të trashëguara brez pas brezi"
      }
    }
  },
  // Scroll Video Experience Section
  experience: {
    title: "Përjetoni Natyrën",
    subtitle: "Lëvizni për të Eksploruar",
    description: "Zhytuni në bukurinë mahnitëse të vendndodhjes sonë agroturistike. Nga kodrat e butë deri tek pamjet panoramike të maleve, zbuloni parajsën natyrore që rrethon restorantin tonë tradicional shqiptar.\n\nShihni si peizazhi zbulohet përpara jush, duke zbuluar mjedisin e paprekur ku rriten përbërësit tanë dhe ku lindin historitë tona.",
  },
  // Events Section
  events: {
    title: "Eventet",
    subtitle: "Krijoni Kujtime të Përhershme",
    text1: "Ullishtja Agroturizem ofron hapësira të bukura dhe atmosferë të ngrohtë për të gjitha ngjarjet tuaja speciale. Nga fejesat tradicionale dhe eventet familjare, ne sigurojmë që çdo moment të jetë i paharrueshëm.",
    text2: "Stafi ynë i dedikuar bashkëpunon me ju për të planifikuar çdo detaj, nga menuja me specialitete lokale, tek dekorimi dhe koordinimi i plotë i eventit.",
    features: {
      weddings: "Fejesë Tradicionale",
      family: "Festa Familjare",
      capacity: "Deri në 60 mysafirë"
    },
    viewMenu: "Menuja e Eventeve"
  },
  // A la Carte Section
  alacarte: {
    title: "Menuja",
    subtitle: "Përjetoni Shijen e Vërtetë Shqiptare",
    text1: "Zbuloni një risi shijesh në menunë tonë, ku çdo pjatë tregon një histori të trashëgimisë kulinare shqiptare. Përbërësit tanë të freskët vijnë nga fermat lokale dhe kopshtet tona.",
    text2: "Nga antipastat tradicionale me djathë të bardhë dhe ullinje, te pjatat kryesore si Shpatull Qingji dhe Pulë me Oriz, çdo vakt përgatitet me kujdesin dhe dashurinë e traditës familjare.",
    features: {
      fresh: "Përbërës të Freskët Çdo Ditë",
      traditional: "Receta të Trashëguara",
      seasonal: "Specialitete Sezonale",
      wine: "Vere Lokale të Përzgjedhura"
    }
  },
  // Menu Section
  menu: {
    title: "Menuja Jonë",
    appetizers: {
      title: "Meze Tradicionale",
      byrek: {
        name: "Byrek me Spinaq",
        desc: "Byrek tradicional me spinaq dhe erbëra të freskëta"
      },
      turshi: {
        name: "Turshi",
        desc: "Perime të turshira në shtëpi"
      },
      cheese: {
        name: "Djathë i Bardhë",
        desc: "Djathë i bardhë lokal i freskët me ullinje"
      }
    },
    mains: {
      title: "Pjata Kryesore",
      tave: {
        name: "Tavë Kosi",
        desc: "Mish qengji i pjekur me kos dhe oriz"
      },
      qofte: {
        name: "Qofte të Fërguara",
        desc: "Qofte tradicionale të fërguara me perime"
      },
      fish: {
        name: "Peshk i Grilluar",
        desc: "Peshk i freskët i grilluar me erbëra mali"
      }
    },
    salads: {
      title: "Sallata të Freskëta nga Ferma",
      village: {
        name: "Sallatë Fshatare",
        desc: "Sallatë fshatare me domate, kastraveca dhe djathë të freskët"
      },
      olive: {
        name: "Sallatë me Ullinje",
        desc: "Gjelbërim i përzier me ullinjtë tona të shtëpisë"
      }
    }
  },
  // Gallery Section
  gallery: {
    title: "Përvojeni Ullishtjen",
    dining: "Ngrënia Tradicionale",
    views: "360°",
    olives: "Ullishtat",
    kitchen: "Kuzhina Jonë"
  },
  // Contact Section
  contact: {
    title: "Na Vizitoni",
    showMap: "Shfaq hartën",
    info: {
      title: "Vendndodhja",
      address: {
        title: "Adresa",
        text: "Fshati Shqiptar\nKontaktoni për drejtime të sakta"
      },
      phone: {
        title: "Telefoni",
        text: " +355 68 409 0405"
      },
      email: {
        title: "Email",
        text: "hi@ullishtja-agroturizem.com"
      },
      hours: {
        title: "Orari",
        text: "E Hënë - E Diel\n11:00 - 22:00"
      },
      whatsapp: {
        title: "WhatsApp",
        text: "+355 68 409 0405"
      }
    },
    reservation: {
      title: "Bëni Rezervim",
      name: "Emri i Plotë",
      email: "Email",
      phone: "Numri i Telefonit",
      guests: "Numri i Mysafirëve",
      guest: "Mysafir",
      guests_plural: "Mysafirë",
      requests: "Kërkesa të Veçanta",
      submit: "Rezervo Tavolinë",
      success: "Rezervimi u dërgua me sukses!",
      error: "Gabim në dërgimin e rezervimit",
      whatsappOption: "Dërgo në WhatsApp",
      emailOption: "Dërgo në Email",
      bothOptions: "Dërgo në të dyja",
      processing: "Duke procesuar...",
      confirmationMessage: "Rezervimi juaj u dërgua me sukses! Kemi marrë njoftimin dhe do t'ju kontaktojmë së shpejti për të konfirmuar rezervimin.",
      timeRestriction: "Orari i rezervimit duhet të jetë midis 10:00 dhe 22:00"
    }
  },
  whatsappFloat: {
    label: "Rezervo",
    ariaLabel: "Hap WhatsApp për të rezervuar një tavolinë",
    message: "Përshëndetje! Dua të rezervoj një tavolinë në Ullishtja Agroturizem."
  },
  menuPage: {
    title: "Menuja",
    subtitle: "Përbërës të freskët, receta tradicionale shqiptare",
    share: "Ndaj",
    copyLink: "Kopjo linkun",
    bookmark: "Ruaj",
    pdf: "PDF",
    copied: "Linku u kopjua",
    bookmarkHint: "Linku u kopjua. Shtypni Ctrl+D (ose ⌘D) për ta ruajtur te shënuesit.",
    shareText: "Shiko menunë e Ullishtja Agroturizem",
    pdfPreparing: "Duke përgatitur PDF...",
    pdfError: "Gabim gjatë krijimit të PDF-së. Provoni përsëri.",
    vegetarian: "Vegjetarian",
    spicy: "I Djegët",
    recommended: "I Rekomanduar",
    ingredients: "Përbërësit",
    loading: "Po ngarkohet menuja...",
    error: "Dështoi ngarkimi i menusë. Provo përsëri.",
    retry: "Provo Përsëri",
    empty: "Menuja është duke u përditësuar."
  },
  notFound: {
    title: "Faqja nuk u gjet",
    text: "Faqja që kërkuat nuk ekziston ose është zhvendosur.",
    home: "Kthehu në faqen kryesore"
  },
  faq: {
    title: "Pyetjet e Shpeshta",
    subtitle: "Gjithçka që duhet të dini para se të na vizitoni",
    items: [
      {
        q: "A duhet të rezervoj tavolinë?",
        a: "Po, rekomandojmë rezervim, sidomos për darkë dhe fundjavë. Na shkruani në WhatsApp ose na telefononi në +355 68 409 0405."
      },
      {
        q: "Cili është orari juaj?",
        a: "Jemi hapur çdo ditë, nga e hëna në të diel, 11:00–22:00."
      },
      {
        q: "Si mund të vij te Ullishtja? A ka parkim?",
        a: "Ndodhemi pranë Durrësit. Përdorni Google Maps ose Apple Maps nga seksioni i kontaktit. Parkimi falas është i disponueshëm në vend."
      },
      {
        q: "A keni opsione vegjetariane?",
        a: "Po. Në menu gjeni sallata, meze dhe pjata të tjera vegjetariane, të shënuara qartë."
      },
      {
        q: "A organizoni dasma dhe evente?",
        a: "Po. Hapësira jonë pret festa familjare dhe evente deri në rreth 60 mysafirë. Na kontaktoni për të planifikuar menunë dhe detajet."
      },
      {
        q: "Si mund të rezervoj?",
        a: "Mënyra më e shpejtë është WhatsApp ose telefonata. Butoni jeshil në faqe hap një mesazh gati për dërgim."
      }
    ]
  },
  // Footer
  footer: {
    copyright: "© 2026 Ullishtja Agroturizem. Të gjitha të drejtat e rezervuara.",
    tagline: "Duke shërbyer kuzhinë autentike shqiptare që nga viti 2021",
    quickLinks: "Linqe të Shpejta",
    services: "Shërbimet",
    alaCarte: "A la Carte",
    events: "Evente",
    organic: "Produkte Organike",
    views: "Pamje Malesh",
    directions: "Drejtimet",
    callUs: "Na Telefononi"
  },
  // Full Menu
  fullMenu: {
    title: "Menuja e Plotë",
    ingredients: "Përbërësit",
    recommended: "I Rekomanduar",
    viewFullMenu: "Shiko Menunë e Plotë",
    categories: {
      appetizers: "Meze",
      soups: "Supa",
      mains: "Pjata Kryesore",
      grilled: "Të Pjekura në Skarë",
      pasta: "Makarona",
      seafood: "Peshk dhe Frutë Deti",
      salads: "Sallata",
      desserts: "Ëmbëlsira",
      beverages: "Pije"
    },
    items: {
      appetizers: [
        {
          name: "Byrek me Spinaq",
          description: "Byrek tradicional me spinaq dhe erbëra të freskëta",
          price: "800 ALL",
          ingredients: "Spinaq, djathë, vezë, erbëra",
          vegetarian: true
        },
        {
          name: "Turshi i Shtëpisë",
          description: "Perime të turshira në mënyrë tradicionale",
          price: "600 ALL",
          ingredients: "Lakra, karota, spec, uthull",
          vegetarian: true
        },
        {
          name: "Djathë i Bardhë me Ullinje",
          description: "Djathë lokal i freskët me ullinje të zonës",
          price: "700 ALL",
          ingredients: "Djathë kope, ullinje, vaj ulliri",
          vegetarian: true
        },
        {
          name: "Suxhuk i Shtëpisë",
          description: "Suxhuk tradicional i bërë në shtëpi",
          price: "1200 ALL",
          ingredients: "Mish viçi, erëza, zorrë natyrale"
        },
        {
          name: "Byrek me Mish",
          description: "Byrek i bollshëm me mish dhe qepë",
          price: "1000 ALL",
          ingredients: "Mish qengji, qepë, erëza"
        }
      ],
      soups: [
        {
          name: "Supë Koke",
          description: "Supë tradicionale me koke qengji",
          price: "1500 ALL",
          ingredients: "Koke qengji, perime, erëza",
          recommended: true
        },
        {
          name: "Supë Pule",
          description: "Supë e ngrohtë me pulë dhe perime",
          price: "1200 ALL",
          ingredients: "Pulë, karota, selino, patate"
        },
        {
          name: "Supë Lëngj",
          description: "Supë e lehtë me perime të stinës",
          price: "800 ALL",
          ingredients: "Perime të ndryshme, erëza",
          vegetarian: true
        }
      ],
      mains: [
        {
          name: "Tavë Kosi",
          description: "Pjata kombëtare shqiptare me mish qengji",
          price: "1800 ALL",
          ingredients: "Mish qengji, kos, oriz, vezë",
          recommended: true
        },
        {
          name: "Qofte të Fërguara",
          description: "Qofte tradicionale me perime",
          price: "1400 ALL",
          ingredients: "Mish i përzier, qepë, bukë"
        },
        {
          name: "Pilaf me Mish",
          description: "Oriz me mish dhe perime",
          price: "1600 ALL",
          ingredients: "Oriz, mish viçi, karota, bizele"
        },
        {
          name: "Mish Koke në Tigan",
          description: "Mish koke i pjekur në tigan me perime",
          price: "2000 ALL",
          ingredients: "Mish koke, patate, spec, domate"
        }
      ],
      grilled: [
        {
          name: "Qofte në Skarë",
          description: "Qofte të pjekura në skarë me erëza",
          price: "1500 ALL",
          ingredients: "Mish i përzier, erëza mali"
        },
        {
          name: "Biftek në Skarë",
          description: "Biftek viçi i pjekur në skarë",
          price: "2200 ALL",
          ingredients: "Mish viçi, erëza, vaj ulliri"
        },
        {
          name: "Speca të Mbushur",
          description: "Speca të mbushur me oriz dhe mish",
          price: "1300 ALL",
          ingredients: "Spec, oriz, mish, domate"
        },
        {
          name: "Mish Qengji në Skarë",
          description: "Mish qengji i pjekur në skarë",
          price: "2500 ALL",
          ingredients: "Mish qengji, erbëra mali, vaj ulliri",
          recommended: true
        }
      ],
      pasta: [
        {
          name: "Makarona me Mish",
          description: "Makarona me salcë mishe dhe perime",
          price: "1200 ALL",
          ingredients: "Makarona, mish i grirë, domate"
        },
        {
          name: "Makarona me Djathë",
          description: "Makarona me djathë dhe krem",
          price: "1000 ALL",
          ingredients: "Makarona, djathë, krem, gjalpë",
          vegetarian: true
        }
      ],
      seafood: [
        {
          name: "Peshk i Grilluar",
          description: "Peshk i freskët i grilluar me erbëra mali",
          price: "2000 ALL",
          ingredients: "Peshk, erbëra, limon, vaj ulliri",
          recommended: true
        },
        {
          name: "Peshk i Pjekur",
          description: "Peshk i pjekur në furrë me perime",
          price: "1800 ALL",
          ingredients: "Peshk, patate, spec, domate"
        }
      ],
      salads: [
        {
          name: "Sallatë Fshatare",
          description: "Sallatë tradicionale me perime të freskëta",
          price: "800 ALL",
          ingredients: "Domate, kastraveca, qepë, djathë",
          vegetarian: true
        },
        {
          name: "Sallatë me Ullinje",
          description: "Sallatë e përzier me ullinje të shtëpisë",
          price: "900 ALL",
          ingredients: "Gjelbërim, ullinje, vaj ulliri",
          vegetarian: true
        },
        {
          name: "Sallatë Greke",
          description: "Sallatë në stil grek me djathë feta",
          price: "1000 ALL",
          ingredients: "Domate, kastraveca, feta, ullinje",
          vegetarian: true
        }
      ],
      desserts: [
        {
          name: "Baklava",
          description: "Ëmbëlsirë tradicionale me arra",
          price: "600 ALL",
          ingredients: "Brumë, arra, mjaltë, kanellë",
          vegetarian: true
        },
        {
          name: "Revan",
          description: "Ëmbëlsirë me irmik dhe sherbet",
          price: "500 ALL",
          ingredients: "Irmik, sheqer, limon, mjaltë",
          vegetarian: true
        },
        {
          name: "Krem Karamel",
          description: "Krem i ëmbël me karamel",
          price: "700 ALL",
          ingredients: "Qumësht, vezë, sheqer, karamel",
          vegetarian: true
        }
      ],
      beverages: [
        {
          name: "Raki Shtëpie",
          description: "Raki tradicionale e distiluar në shtëpi",
          price: "300 ALL",
          ingredients: "Rrush, distilim tradicional"
        },
        {
          name: "Verë e Kuqe Lokale",
          description: "Verë e prodhuar në rajon",
          price: "400 ALL",
          ingredients: "Rrush lokal"
        },
        {
          name: "Çaj Mali",
          description: "Çaj i mbledhur nga malet e zonës",
          price: "200 ALL",
          ingredients: "Erbëra mali, mjaltë",
          vegetarian: true
        },
        {
          name: "Lëng Frutash",
          description: "Lëng i freskët nga frutat e kopshtit",
          price: "300 ALL",
          ingredients: "Fruta sezonale",
          vegetarian: true
        }
      ]
    }
  },
  // Google Reviews Section
  googleReviews: {
    title: "Çfarë Thonë Mysafirët Tanë",
    basedOn: "Bazuar në",
    googleReviews: "recensione Google",
    viewOnGoogle: "Shiko në Google",
    showMoreReviews: "Trego Më Shumë Recensione",
    remaining: "të mbetura",
    showLessReviews: "Trego Më Pak Recensione",
    seeMore: "Shiko Më Shumë",
    showLess: "Shiko Më Pak",

    writeReview: "Shkruaj një Recensione në Google",
    loadingReviews: "Duke ngarkuar recensionet...",
    unableToLoad: "Nuk mund të ngarkojmë recensionet në këtë moment."
  },
  creatorVideos: {
    title: "Si na shohin krijuesit",
    subtitle: "Video nga vizitorë që e treguan Ullishten me sytë e tyre"
  },
  // Blog Section
  blog: {
    title: "Blogu i Ullishtes",
    subtitle: "Histori nga zemra e agroturizmit shqiptar",
    readMore: "Lexo Më Shumë",
    readLess: "Lexo Më Pak",
    publishedOn: "Publikuar më",
    tags: "Etiketa",
    backToBlog: "Kthehu tek Blogu",
    relatedPosts: "Artikuj të Ngjashëm",
    categories: {
      agriculture: "Bujqësi",
      sustainability: "Qëndrueshmëri",
      tradition: "Traditë",
      recipes: "Receta",
      nature: "Natyra"
    },
    posts: {
      sustainableFarming: {
        title: "Bujqësia e Qëndrueshme: Rruga drejt së Ardhmes",
        excerpt: "Zbuloni si fermat moderne mund të ruajnë mjedisin dhe të prodhojnë ushqim cilësor përmes praktikave të qëndrueshme.",
        content: `
            Bujqësia e qëndrueshme është më shumë se një trend - është një mënyrë jetese që respekton natyrën dhe krijon ekuilibër midis prodhimit dhe ruajtjes së mjedisit.
            
            <h3>Çfarë do të thotë Bujqësi e Qëndrueshme?</h3>
            
            Bujqësia e qëndrueshme është një sistem prodhimi që ruan dhe përmirëson cilësinë e mjedisit, përdor burimet natyrore në mënyrë efektive dhe siguron jetesën ekonomike të fermës. Ajo përfshin praktika si:
            
            • <strong>Rotacioni i Kulturave:</strong> Ndryshimi i kultivimeve për të ruajtur fertilitetin e tokës
            • <strong>Kontrolli Biologjik:</strong> Përdorimi i armiqve natyrorë të dëmtuesve në vend të pesticidev kimikë
            • <strong>Kompostimi:</strong> Riciklimi i mbeturinave organike për të krijuar pleh natyror
            • <strong>Menaxhimi i Ujit:</strong> Përdorimi efektiv i burimeve ujore
            
            <h3>Përfitimet për Mjedisin</h3>
            
            Praktikimi i bujqësisë së qëndrueshme sjell përfitime të shumta:
            
            <strong>Mbrojtja e Tokës:</strong> Praktikat e qëndrueshme parandalojnë erozioni dhe ruajnë strukturën e tokës.
            
            <strong>Biodiversiteti:</strong> Kultivimi i shumëllojshmërisë së bimëve dhe ruajtja e habitateve natyrore.
            
            <strong>Cilësia e Ujit:</strong> Reduktimi i përdorimit të kimikalieve që ndotin ujerat.
            
            <h3>Tek Ullishtja: Një Model i Suksesshëm</h3>
            
            Në Ullishtja Agroturizem, ne zbatojmë këto parime çdo ditë. Kopshtet tona organikë prodhojnë perime të freskëta pa pesticide, ndërsa sistemet tona të kompostimit sigurojnë që asgjë nuk shkërdhehet.
            
            Ullishtat tanë janë kultivuar sipas metodave tradicionale që kanë qenë të qëndrueshme për shekuj. Ky kombinim i traditës me praktikat moderne krijon ushqim jo vetëm të shijshëm, por edhe të shëndetshëm për ju dhe mjedisin.
            
            <h3>Si Mund të Kontribuoni</h3>
            
            Si konsumatorë, ju mund të mbështesni bujqësinë e qëndrueshme duke:
            
            • Zgjedhur ushqime lokale dhe organike
            • Vizituar ferma që zbatojnë praktika të qëndrueshme
            • Mësuar rreth origjinës së ushqimit tuaj
            • Mbështetur biznese si Ullishtja që vënë mjedisin në qendër
            
            E ardhmja e bujqësisë qëndhet në duart tona të gjithëve. Së bashku, mund të krijojmë një sistem ushqimor që ushqen njerëzit dhe planeten.
          `
      },
      traditionalCooking: {
        title: "Kuzina Tradicionale Shqiptare: Receta të Trashëguara brez pas brezi",
        excerpt: "Eksploroni sekretet e kuzhinës shqiptare dhe mësoni si recetat tradicionale ruhen dhe transmetohen.",
        content: `
            Kuzina shqiptare është një thesar kulturor që rrëfën historinë e një populli përmes shijeve, aromave dhe ritualeve të gatimit. Çdo recetë bart në vete kujtesa familjare dhe traditë që kanë kaluar nga gjyshja tek nipërit.
            
            <h3>Themelët e Kuzhinës Shqiptare</h3>
            
            Kuzina shqiptare ndërtohet mbi disa parime themelore:
            
            <strong>Përbërës të Freskët Lokalë:</strong> Traditën shqiptare e di që cilësia e ushqimit fillon nga përbërësit. Perime nga kopshti, mish nga fermët lokale, dhe djathë i bërë në shtëpi janë bazat e çdo vakte të mirë.
            
            <strong>Metoda të Ngadalta Gatimi:</strong> Pjatat shqiptare më të mira kërkojnë kohë. Gatimi i ngadaltë lejon që shijen të zhvillohen plotësisht dhe përbërësit të marrin shqim njëri-tjetrin.
            
            <strong>Ndarja dhe Komuniteti:</strong> Ushqimi shqiptar nuk është vetëm për ngopur, por për të mbledhur familjen dhe miqtë rreth tavolinës.
            
            <h3>Recetat Ikona</h3>
            
            <strong>Tavë Kosi - Pjata Kombëtare</strong>
            
            Tavë kosi është më shumë se një pjatë - është simboli i mikpritjes shqiptare. Mishi i njomë i qengjit përzihet me kos të freskët dhe oriz, duke krijuar një harmoni shije që ka kënaqur breza të tërë.
            
            Sekreti qëndron në kualitetin e kosit - i bërë me qumësht të freskët dhe baktere të dobishme që I japin shijen e veçantë acid-të ëmbla.
            
            <strong>Byrek - Arti i Brumit</strong>
            
            Byrek kërin aftësi dhe durim. Shtimi dhe zgjatja e brumit së hollë sa letër është një artë që mpsohet vetëm përmes praktikës dhe përvojës. Mbushi mund të jetë me spinaq, djathë, mish, ose perime - çdo variant tregon një histori të ndryshme.
            
            <strong>Qofte - Traditë e Thjeshtë</strong>
            
            Qofte mund të duken të thjeshta, por në realitet kërkojnë balancë të përpiktë të erëzave dhe teknikën e duhur të përzierjes. Çdo familje ka sekretin e vet, nga erëza që përdor deri tek mënyra e formimit.
            
            <h3>Trashëgimia në Ullishtja</h3>
            
            Në Ullishtja Agroturizem, ne nderojmë këto traditë duke përdorur receta origjinale që janë testuar nga koha. Gjyshja ime më mësoi se çdo pjatë duhet të përgatitet me zemër, jo vetëm me duar.
            
            Kuzhinierët tanë janë trashëgimtarë të këtyre tradicionaleve. Ata nuk përdorin vetëm receta, por mundohen të bartin shpirtin e kuzhinës shqiptare në çdo vakt që përgatsin.
            
            <h3>Si të Ruajmë Traditat</h3>
            
            Ruajtja e traditave kulinare kërkon përpjekje të vazhdueshme:
            
            • <strong>Mësoni nga të moshuarit:</strong> Gjyshet dhe gjyshërit janë biblioteka jetëse e recetave tradicionale
            • <strong>Praktikoni rregullisht:</strong> Traditë ruhet vetëm nëse praktikohet
            • <strong>Përcilleni:</strong> Mësojini fëmijët tuaj recetat që ju keni mësuar
            • <strong>Respektoni origjinalitetin:</strong> Ndërsa është e shëndetshme të përshtasësh, është e rëndësishme të ruash thelbin
            
            Kuzina shqiptare është më shumë se ushqim - është identitet, është dashuri, është mënyrë për të lidhur brezat dhe për të ruajtur shpirtin e një populli të pasur me traditë.
          `
      },
      seasonalIngredients: {
        title: "Përbërës Sezonalë: Rithmi Natyror i Ushqimit",
        excerpt: "Zbuloni bukurinë e gatimit me përbërës sezonalë dhe si kjo praktikë përfiton shëndetin dhe mjedisin.",
        content: `
            Gatimi me përbërës sezonalë nuk është vetëm një trend modern - është kthimi tek mënyra natyror e ushqyerjes që njerëzit kanë praktikuar për mijëra vjet. Kjo qasje na lidh me rithmin e natyrës dhe na ofron ushqim në cilësinë më të mirë.
            
            <h3>Çfarë Nënkupton Gatimi Sezonal?</h3>
            
            Gatimi sezonal do të thotë përdorimi i frutave dhe perimeve në kohën kur ato rriten natyralisht në vendndodhjen tuaj. Ky është koncepti që ka udhëhequr kuzhinën shqiptare për shekuj.
            
            <h3>Stinët dhe Dhuntitë e Tyre</h3>
            
            <strong>Pranvera - Rilindje dhe Freski</strong>
            
            Pranvera sjell me vete:
            • <strong>Erbëra të egra:</strong> Radeqe, spinaq i egër, lëpja
            • <strong>Qepë të gjelbra:</strong> Të njoma dhe aromatike
            • <strong>Sallatë të para:</strong> Të buta dhe të freskëta
            • <strong>Espanaqi:</strong> I bollshëm me vitamine
            
            Këta përbërës janë të përsosur për pjata të lehta që pastrojnë trupin pas dimrit.
            
            <strong>Vera - Bollëk dhe Ngjyra</strong>
            
            Vera na dhuron:
            • <strong>Domate të kuqe:</strong> Të ëmbla dhe të lëngshme
            • <strong>Speca në të gjitha ngjyrat:</strong> Të pasur me vitaminë C
            • <strong>Patëllxhane:</strong> Mish bimore për pjata të ngopur
            • <strong>Kastraveca:</strong> Freskues natyror
            • <strong>Frutë të ëmbla:</strong> Pjeshkë, qershi, mollë të hershme
            
            <strong>Vjeshta - Korrje dhe Pergaditje</strong>
            
            Vjeshta sjell:
            • <strong>Kungull:</strong> Baza e supave të ngrohta
            • <strong>Mollë dhe dardha:</strong> Të përsosura për ëmbëlsira
            • <strong>Arra dhe bajame:</strong> Energji për dimrin
            • <strong>Rrush:</strong> I freskët apo i përdorur për verë
            
            <strong>Dimri - Ruajtje dhe Ngrohtësi</strong>
            
            Dimri ofron:
            • <strong>Lakra:</strong> Bazë për turshi dhe sallatat e dimrit
            • <strong>Karota dhe panxhar:</strong> Të ruajtur dhe plot energji
            • <strong>Patate dhe qepë:</strong> Ushqim themelor
            • <strong>Ullinje:</strong> Fryt i çmuar i dimrit
            
            <h3>Përfitimet e Gatimit Sezonal</h3>
            
            <strong>Përfitime Shëndetësore</strong>
            
            Ushqimi sezonal ofron:
            • Vitamine dhe minerale në përqendrimin më të lartë
            • Antioksidantë natyrorë që ndryshojnë sipas nevojave të sezonit
            • Freski maksimale dhe shije të superiore
            • Shumëllojshmëri natyrore në dietë
            
            <strong>Përfitime Mjedisore</strong>
            
            • Reduktim i gjurmës së karbonit (transporti më i shkurtër)
            • Mbështetje e ekonomisë lokale
            • Redukton nevojën për pesticide dhe konservantë
            • Ruan biodiversitetin e kultivimeve
            
            <h3>Ullishtja dhe Gatimi Sezonal</h3>
            
            Në Ullishtja Agroturizem, menyja jonë ndryshon me stinët. Në pranverë, shërbejmë byrek me erbëra të egra që mblidhen në kodrat përreth. Në verë, sallatat tona janë plot me domate dhe kastraveca nga kopshti ynë.
            
            Vjeshta sjell receta të ngrohta me kungull dhe rrënjë, ndërsa dimri na gjen duke shërbyer turshi të bëra në shtëpi dhe vakte të ngrohta që ngasin ftohtësinë.
            
            <h3>Filloni të Gateni Sezonalisht</h3>
            
            • <strong>Vizitoni tregje lokale:</strong> Shihni çfarë është në sezon
            • <strong>Mësoni për stinën:</strong> Studijoni se çfarë rritet kur
            • <strong>Krijoni marëdhënie:</strong> Lidhuni me fermerët lokalë
            • <strong>Konservoni bollëkun:</strong> Mësoni të ruani ushqimet për stinët e varfra
            • <strong>Eksperimentoni:</strong> Provoni receta të reja me përbërësit e sezonit
            
            Gatimi sezonal na kujton se jemi pjesë e një sistemi më të madh natyror. Duke respektuar ritmin e stinëve, ne nderojmë natyrën dhe veten tonë.
          `
      },
      agrotourismBenefits: {
        title: "Përfitimet e Agroturizmit për Komunitetin Rural",
        excerpt: "Si agroturizmi po ndryshon jetën rurale duke sjellë zhvillim ekonomik dhe ruajtje të traditave.",
        content: `
            Agroturizmi është shumë më tepër se thjesht udhëtime në fshat. Është një forcë e fuqishme që po transformon komunitetet rurale, duke sjellë mundësi të reja ekonomike dhe duke ruajtur trashëgiminë kulturore për brezat e ardhshëm.
            
            <h3>Çfarë është Agroturizmi?</h3>
            
            Agroturizmi kombinon aktivitetin bujqësor me turizmin, duke u mundësuar vizitorëve të përjetojnë jetën rurale në mënyrë autentike. Kjo përfshin qëndrimin në ferma, pjesëmarrjen në aktivitete bujqësore, dhe shijon e ushqimit tradicional.
            
            <h3>Përfitimet Ekonomike</h3>
            
            <strong>Të Ardhura Shtesë për Fermerët</strong>
            
            Agroturizmi krijon burime alternative të ardhurash për familjet rurale:
            • Qiraja e dhomave ose shtëpive të vogla
            • Shitja e produkteve organike direkt nga ferma
            • Organizimi i aktiviteteve edukative
            • Shërbimet e ushqimit traditional
            
            <strong>Krijon Punësim Lokal</strong>
            
            Zhvillimi i agroturizmit krijon:
            • Vende pune për të rinjtë ruralë
            • Mundësi për gratë që të kontribuojnë ekonomikisht
            • Nevoja për shërbime mbështetëse (transport, udhëzime)
            • Zhvillim të artizanatit lokal
            
            <strong>Investime në Infrastrukturë</strong>
            
            Turizmi nxit:
            • Përmirësimin e rrugëve dhe komunikacioneve
            • Zhvillimin e shërbimeve publike
            • Modernizimin e fermave
            • Krijon standarde të reja cilësie
            
            <h3>Ruajtja e Kulturës dhe Traditave</h3>
            
            <strong>Trasmetimi i Njohurive Tradicionale</strong>
            
            Agroturizmi ruan:
            • Teknikat tradicionale të bujqësisë
            • Recetat familjare të gatimit
            • Zanat dhe artizanat tradicional
            • Gjuhën dhe folklorn vendor
            
            <strong>Përjetimi Autentik</strong>
            
            Vizitorët mësojnë:
            • Si prodhohen ushqimet organike
            • Rëndësinë e cikleve natyrore
            • Vlerën e punës së vështirë
            • Respektin për natyrën
            
            <h3>Përfitimet Mjedisore</h3>
            
            <strong>Bujqësia e Qëndrueshme</strong>
            
            Agroturizmi nxit:
            • Praktikat organike të kultivimit
            • Ruajtjen e varieteve lokale
            • Mbrojtjen e peizazhit rural
            • Zvogëlimin e përdorimit të kimikalieve
            
            <strong>Edukimi Mjedisor</strong>
            
            Vizitorët kuptojnë:
            • Rëndësinë e biodiversitetit
            • Lidhjen midis ushqimit dhe mjedisit
            • Nevojën për ruajtjen e tokës
            • Vlerat e konsumit të përgjegjshëm
            
            <h3>Ullishtja: Një Model i Suksesshëm</h3>
            
            Ullishtja Agroturizem ilustron këto përfitime:
            
            <strong>Për Komunitetin:</strong>
            • Krijon punësim për 15 persona lokale
            • Blen produkte nga fermerët e zonës
            • Organizon aktivitete edukative për fëmijët
            • Mbështet artizanët lokalë
            
            <strong>Për Mjedisin:</strong>
            • Kultivon ushqime organike
            • Ruan varietete tradicionale ullinjash
            • Përdor energji të rinovueshme
            • Praktikon menaxhim të qëndrueshëm të mbeturinave
            
            <strong>Për Vizitorët:</strong>
            • Ofron përvojë autentike rurale
            • Mundësi mësimi për fëmijët
            • Lidhje me origjinën e ushqimit
            • Relaksim në mjedis natyror
            
            <h3>Sfidat dhe Zgjidhjet</h3>
            
            <strong>Sfida kryesore:</strong>
            • Mungesa e infrastrukturës në disa zona
            • Nevoja për trajnim në mikpritje
            • Standardizimi i shërbimeve
            • Marketing dhe promovimi
            
            <strong>Zgjidhje të mundshme:</strong>
            • Bashkëpunim midis fermave të ndryshme
            • Trajnime për zhvillim të aftësive
            • Përdorimi i teknologjisë për promovim
            • Mbështetje nga qeveria lokale
            
            <h3>E Ardhmja e Agroturizmit</h3>
            
            Agroturizmi ka potencial të madh për:
            • Reduktimin e migrimit rural-urban
            • Krijimin e komuniteteve të qëndrueshme
            • Ruajtjen e trashëgimisë kulturore
            • Zhvillimin e turizmit të përgjegjshëm
            
            Investimi në agroturizëm është investim në të ardhmen e komuniteteve rurale, në ruajtjen e traditave, dhe në krijimin e një ekonomie të qëndrueshme që respekton natyrën dhe kulturën.
          `
      },
      organicFarming: {
        title: "Bujqësia Organike: Kthimi tek Natyra",
        excerpt: "Eksploroni parimet e bujqësisë organike dhe përfitimet që sjell për shëndetin, mjedisin dhe ekonominë lokale.",
        content: `
            Bujqësia organike përfaqëson kthimin tek metodat tradicionale të kultivimit që kanë ushqyer njerëzimin për mijëra vjet, por tani janë të përshtatura me njohuritë shkencore moderne. Ky sistem është bazuar në respektimin e proceseve natyrore dhe krijimin e harmonis së qëndrueshme midis njeriut dhe natyrës.
            
            <h3>Parimet Kryesore të Bujqësisë Organike</h3>
            
            <strong>Parimi i Shëndetit</strong>
            Bujqësia organike duhet të mbështesë dhe nxisë shëndetin e tokës, bimëve, kafshëve, njerëzve dhe planetit si një e tërë e vetme dhe e ndarë.
            
            <strong>Parimi i Ekologjisë</strong>
            Bujqësia organike duhet të bazohet në sisteme dhe cikle ekologjike jetësore, të punojë me to, t'i imitojë dhe t'i mbështesë.
            
            <strong>Parimi i Drejtësisë</strong>
            Bujqësia organike duhet të ndërtojë marrëdhënie që sigurojnë drejtësi në lidhje me ambientin e përbashkët dhe mundësitë jetësore.
            
            <strong>Parimi i Kujdesit</strong>
            Bujqësia organike duhet të menaxhohet në mënyrë paraprake dhe me përgjegjësi për të mbrojtur shëndetin dhe mirëqenien e brezave aktualë dhe të ardhshëm dhe mjedisit.
            
            <h3>Praktikat e Bujqësisë Organike</h3>
            
            <strong>Menaxhimi i Tokës</strong>
            
            • <strong>Rotacioni i Kulturave:</strong> Ndryshimi i kultivimeve për të ruajtur fertilitetin natyror
            • <strong>Kulturat Mbështetëse:</strong> Mbjella të cilat përmirësojnë cilësinë e tokës
            • <strong>Kompostimi:</strong> Përdorimi i materialeve organike për plehërimin natyror
            • <strong>Kontrolli i Erozioni:</strong> Teknika për të mbrojtur tokën nga degradimi
            
            <strong>Kontrolli Natyror i Dëmtuesve</strong>
            
            • <strong>Kontrolli Biologjik:</strong> Përdorimi i armiqve natyrorë të dëmtuesve
            • <strong>Kultivimi i Bimëve Mbrojtëse:</strong> Bimë që dëbojnë insektet e dëmshëm
            • <strong>Bariereva Fizike:</strong> Rrjeta dhe pengesa natyrale
            • <strong>Rotacioni i Kulturave:</strong> Që ndërpret ciklet e dëmtuesve
            
            <strong>Ruajtja e Ujit</strong>
            
            • <strong>Sisteme Vaditjeje Efikase:</strong> Pikë-pikë ose sisteme që ruajnë ujin
            • <strong>Mulching:</strong> Mbulesa organike që ruajnë lagështinë
            • <strong>Zgjedhja e Kulturave:</strong> Bimë të përshtatura me klimën lokale
            • <strong>Grumbullimi i Ujit të Shiut:</strong> Për përdorim të mëvonshëm
            
            <h3>Përfitimet e Bujqësisë Organike</h3>
            
            <strong>Përfitime për Shëndetin</strong>
            
            Ushqimet organike ofrojnë:
            • Nivel më të lartë vitaminash dhe mineralesh
            • Më shumë antioksidantë natyrorë
            • Zero mbetje pesticidev dhe herbicidesh
            • Më pak rrisk për sëmundje kronike
            • Shije më të pastër dhe më intensive
            
            <strong>Përfitime Mjedisore</strong>
            
            • <strong>Mbrojtja e Biodiversitetit:</strong> Promovon jetën e egër dhe varietetin e bimëve
            • <strong>Cilësia e Ujit:</strong> Nuk ndot burimet ujore me kimikate
            • <strong>Shëndeti i Tokës:</strong> Përmirëson strukturën dhe fertilitetin
            • <strong>Reduktimi i Gazrave Serrë:</strong> Praktika që kapturajnë karbonin
            
            <strong>Përfitime Ekonomike</strong>
            
            • Çmime më të larta për produktet organike
            • Reduktim i kostove të kimikalieve
            • Turizëm i qëndrueshëm
            • Mbështetje nga konsumatorët e ndërgjegjshëm
            
            <h3>Ullishtja dhe Bujqësia Organike</h3>
            
            Në Ullishtja Agroturizem, ne kemi përqafuar plotësisht parimet e bujqësisë organike:
            
            <strong>Kopshtet Tona:</strong>
            • Kultivohemi perime pa përdorur pesticide ose plehëra kimike
            • Përdorim kompost të bërë nga mbeturinat e kuzhinës
            • Praktikojmë rotacionin e kulturave për të ruajtur fertilitetin
            • Mbledhim ujin e shiut për vaditje
            
            <strong>Ullishtat:</strong>
            • Janë kultivuar organikisht për mbi 50 vjet
            • Përdorim metoda tradicionale të kujdesit
            • Nuk përdorim herbicide ose pesticide
            • Ruajmë varietete lokale tradicionale
            
            <strong>Shërbimet tona:</strong>
            • Gjithë ushqimet përgatiten me përbërës organikë
            • Menyta ndryshon sipas sezonit dhe disponibilitetit
            • Edukojmë vizitorët për përfitimet e ushqimit organik
            • Shisin produktet tona organike direkt nga ferma
            
            <h3>Si të Filloni Bujqësinë Organike</h3>
            
            <strong>Për Fermerët e Rinj:</strong>
            
            • <strong>Filloni me pak:</strong> Zgjidhni një sipërfaqe të vogël për eksperimentim
            • <strong>Mësoni vazhidimisht:</strong> Ndiqni kurse dhe trajnime për bujqësi organike
            • <strong>Lidhuni me komunitetin:</strong> Bashkohuni me fermerë të tjerë organikë
            • <strong>Kërkoni certifikim:</strong> Ndjekni procesin e certifikimit organik
            
            <strong>Për Konsumatorët:</strong>
            
            • <strong>Mbështesni fermerët lokalë:</strong> Blini direkt nga fermat organike
            • <strong>Vizitoni fermat:</strong> Mësoni se si prodhohen ushqimet organike
            • <strong>Lexoni etiketat:</strong> Kërkoni certifikimet organike të besueshme
            • <strong>Përhapni informacionin:</strong> Ndani njohuritë me familjen dhe miqtë
            
            <h3>E Ardhmja e Bujqësisë Organike</h3>
            
            Bujqësia organike nuk është vetëm një trend, por një domosdoshmëri për:
            • Ushqyerjen e një popullate në rritje
            • Mbrojtjen e mjedisit për brezat e ardhshëm
            • Krijimin e sistemeve ushqimore të qëndrueshme
            • Ruajtjen e biodiversitetit
            
            Investimi në bujqësinë organike është investim në shëndetin tonë, mjedisin dhe të ardhmen e planetit. Çdo hap drejt praktikave organike është hap drejt një bote më të shëndetshme.
          `
      }
    }
  }
};

export default al;
